import React, { useState } from "react"
import { useTranslation } from "@/langs/useTranslation";
import {
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  TextField,
  Grid,
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import useStyles from "./reduceStyle";

const DuringExecute = ({readonly, editData, values, handleChange}) => {
  const { t } = useTranslation("");
  const classes = useStyles();
  const [loading, setLoading] = useState(false)

  const saveDate = name => date => {
    handleChange({
      target: {
        name,
        value: date.valueOf()
      }
    })
  }

  return (
    <div className={classes.datePicker}>
      <DatePicker
        value={values.effectBeginTime}
        disabled={loading || readonly}
        placeholder={t({defaultMessage: "请选择时间"})}
        onChange={saveDate("effectBeginTime")}
        inputFormat="YYYY/MM/DD"
        minDate={!editData ? new Date() : undefined}
        minDateMessage={t({defaultMessage: "您选择的开始日期早于今天"})}
        renderInput={props => <TextField {...props} />}
      />
      <RadioGroup
        aria-label="date"
        className="dateGroup"
        value={values.effectType}
        onChange={handleChange}
        style={{marginLeft: 32}}
        name="effectType"
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl className="ml-2">
              <FormControlLabel
                disabled={readonly}
                value="1"
                control={<Radio color="primary" />}
                label={t({ defaultMessage: "持续" })}
                style={{margin: 0}}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl className="ml-2">
              <FormControlLabel
                style={{margin: 0}}
                disabled={readonly}
                value="2"
                control={<Radio color="primary" />}
                label={
                  <div className="flex_center">
                    <div className="mr-2" style={{marginRight: 24}}>
                      {t({defaultMessage: "结束日期"})}
                    </div>
                    <DatePicker
                      value={values.effectEndTime}
                      name="effectEndTime"
                      disabled={loading || readonly}
                      placeholder={t({defaultMessage: "清选择时间"})}
                      onChange={saveDate("effectEndTime")}
                      inputFormat="YYYY/MM/DD"
                      minDate={new Date()}
                      minDateMessage={t({defaultMessage: "您选择的开始日期早于今天"})}
                      renderInput={props => <TextField {...props} />}
                      InputProps={{
                        onFocus: () => {
                          handleChange({target: {
                            name: 'effectType',
                            value: "2"
                          }})
                        }
                      }}
                    />
                  </div>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl className="ml-2">
              <FormControlLabel
                style={{margin: 0}}
                disabled={readonly}
                value="3"
                control={<Radio color="primary" />}
                label={
                  <div className="flex_center">
                    <TextField
                      disabled={readonly}
                      value={values.effectTimes}
                      type="number"
                      onFocus= {() => {
                          handleChange({target: {
                            name: 'effectType',
                            value: "3"
                          }})
                        }}
                      onChange={e => {
                        handleChange(e)
                      }}
                      style={{ width: "60px" }}
                      inputProps={{ min: 1 }}
                      name="effectTimes"
                    />
                    <div className="ml-2">
                      {t({defaultMessage: "次"})}
                      {values.effectTimes < 1 && (
                        <Typography
                          color="error"
                          component="span"
                          style={{ marginLeft: 8 }}
                        >
                          {t({ defaultMessage: "输入下限：1" })}
                        </Typography>
                      )}
                      {values.effectTimes > 30 && (
                        <Typography
                          color="error"
                          component="span"
                          style={{ marginLeft: 8 }}
                        >
                          {t({ defaultMessage: "输入上限：30" })}
                        </Typography>
                      )}
                    </div>
                  </div>
                }
              />
            </FormControl>
          </Grid>
        </Grid>
      </RadioGroup>
    </div>
  )
}

export default DuringExecute